<template>
  <v-layout row wrap>
    <v-flex xs12>
      <template v-if="false">
        <v-layout row wrap>
          <v-flex v-for="(loading, key) in loadings" :key="key" xs12>
            {{ loading }}: {{ key }}
          </v-flex>
        </v-layout>
      </template>
      <template v-if="isLoading">
        <v-layout row wrap>
          <Loading />
          <v-flex xs12 class="grey--text text-xs-center">
            {{
              $t('loading.sports', {
                num:
                  Object.keys(loadings).filter(key => !loadings[key] && !key.includes('matches_'))
                    .length +
                  '/' +
                  Object.keys(loadings).filter(key => !key.includes('matches_')).length,
              })
            }}
          </v-flex>
          <v-flex xs12 class="grey--text text-xs-center">
            {{
              $t('loading.clubs', {
                num:
                  Object.keys(loadings).filter(key => !loadings[key] && key.includes('matches_'))
                    .length +
                  '/' +
                  Object.keys(loadings).filter(key => key.includes('matches_')).length,
              })
            }}
          </v-flex>
        </v-layout>
      </template>
      <template v-else-if="hasDbError">
        <Error v-for="(error, key) in dbErrors" v-if="error" :key="key" error="error" />
      </template>
      <template v-else>
        <v-layout row wrap>
          <template v-if="!isLoggedUser">
            <v-flex xs12>
              <v-alert
                :value="true"
                outline
                class="mb-3"
                color="success"
                v-html="$t('general.messages.createClub', { email: $t('site.email') })"
              />
            </v-flex>
          </template>
          <v-flex xs12>
            <h1 class="primary--text text-xs-center" @click="navigateTo({ name: 'Sports' })">
              {{ $t(`sport.types.${sport}.name`) }}
            </h1>
          </v-flex>
          <BaseTable
            :page="page"
            :entity="entity"
            :items="sportClubs"
            :model="model"
            :admin-mode="isLoggedUser"
            :allow-add="isLoggedUser"
            :allow-edit="isLoggedUser"
            :allow-delete="isLoggedUser"
            :need-invitation="true"
            group-by="type"
            @onAdd="onAdd"
            @onUpdate="onUpdate"
            @onDelete="onDelete"
            @onGo="onGo"
          >
            <ClubCard
              slot="card"
              slot-scope="{ item }"
              :item="item"
              :is-club-admin="isClubAdmin(item)"
              :year="yearId"
              :week="weekId"
            />
          </BaseTable>
          <v-flex xs12 class="mt-5">
            <MatchesListContainer :clubs="clubs" :matches="matchesListData" />
          </v-flex>
          <v-flex xs12 class="mt-3">
            <WeekNavigation
              :year="year"
              :week="week"
              :week-dates="weekDates"
              @movePrevWeek="movePrevWeek"
              @moveNextWeek="moveNextWeek"
            />
          </v-flex>
        </v-layout>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
// import Vue from 'vue'
import _ from 'lodash'
import ClubsLib from '@/lib/data/clubs'
import UserClubsLib from '@/lib/data/userClubs'
import MatchesLib from '@/lib/data/matches'
import clubModel from '@/lib/data/models/club'
import Loading from '@/components/UIComponents/Loading/Loading'
import Error from '@/components/UIComponents/Error/Error'
import BaseMixin from '@/components/Dashboard/Mixin/BaseMixin'
import MatchHelper from '@/lib/MatchHelper'
import SportHelper from '@/lib/SportHelper'
import DateHelper from '@/lib/DateHelper'

import MetaHelper from '@/lib/MetaHelper'
import SecurityHelper from '@/lib/SecurityHelper'
import BaseTable from '@/components/Base/BaseTable'
import BaseTableTextArea from '@/components/Base/TableFields/BaseTableTextArea'
import ClubCard from '@/components/Dashboard/Views/Clubs/Templates/ClubCard'
import WeekNavigation from '@/components/Dashboard/Views/Clubs/Templates/WeekNavigation'
import MatchesListContainer from '@/components/Dashboard/Views/Clubs/Templates/MatchesListContainer'
const debug = require('debug')('OD::Clubs')

export default {
  name: 'Clubs',
  components: {
    BaseTable,
    ClubCard,
    MatchesListContainer,
    BaseTableTextArea,
    Loading,
    Error,
    WeekNavigation,
  },
  mixins: [BaseMixin],
  props: {
    sport: {
      type: String,
      required: true,
    },
    yearId: {
      type: String,
      default: '',
    },
    weekId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      page: 'clubs',
      entity: 'club',
      sportIndex: null,
      clubs: [],
      sports: [],
      matches: {},
      userClubs: [],
      matches_CKZkxVtg9xDJxfLsiR5m: [],
      matches_cWi1M9kkSnKzFR2nVSgA: [],
      matches_jkSUfpHeqkZautmWUEjt: [],
      matches_xLEXpnK5LrQsH9HjjORc: [],
      matches_ZLZLXhFHNIJGojpoa954: [],
      matches_T96Sg3AyOJ9nT7yfjWN0: [],
      matches_mkgu6Ss0GmjyjiGBJ8od: [],
      matches_7DjVIkqn2eZcyw0X8uyE: [],
      matches_wyASZ2GfBx4UfnLyFYAe: [],
      matches_2LnrTngM5u8CJsmaQWJw: [],
      matches_Q5HUpcnmLW3Xmj7o4P23: [],
      matches_UpvnVcYqEAdNsZjLOxkP: [],
      matches_eXX4oCnvJo8B9jJh6xis: [],
      matches_hdyOC2C9KPq6aG7PBqxW: [],
      matches_njeDdGOq4AwA7uUeMpVw: [],
      matches_0HqZjr3UTM2tzWmjMfz2: [],
      matches_1CjTqjZvfBgKNnY81inw: [],
      matches_ZfMTnZ2rgYde5ICA4PPv: [],
      matches_h0xCo3bcnXeGhSXt8XS8: [],
      matches_X3d53YbJvGaFqyUt2tbh: [],
      matches_GsOPPiTJbpbRwlBFN4YS: [],
      matches_0OeHuu53VFk5dYtcXJDi: [],
      loadings: {
        clubs: true,
        userClubs: true,
      },
      dbErrors: {
        clubs: null,
        userClubs: null,
      },
    }
  },
  computed: {
    matchesListData() {
      const matchesFilter = {}
      debug('matchesFilter 1', { sportClubs: this.sportClubs, matches: this.matches })
      if (this.sportClubs && this.matches) {
        this.matches.forEach(match => {
          const sportType = match.config.name
          const sportName = match.config.sport
          if (this.sport === sportName) {
            matchesFilter[sportType] = Object.assign({}, match)
          }
        })
      }
      debug('matchesFilter 2', matchesFilter)
      return _.values(matchesFilter)
    },
    model() {
      return clubModel
    },
    isLoading() {
      return _.values(this.loadings).filter(loading => loading).length > 0
    },
    hasDbError() {
      return _.values(this.dbErrors).filter(error => error && error !== '').length > 0
    },
    isLoggedUser() {
      return SecurityHelper.isLoggedUser(this.currentUser)
    },
    sportClubs() {
      return this._sportClubs[this.sport] || []
    },
    _sportClubs() {
      const items = this.clubs.slice(0)
      const sports = {}
      items.forEach(item => {
        if (!item.hide) {
          const sport = SportHelper.getSportConfiguration(item.sport).sport
          if (!(sport in sports)) {
            sports[sport] = []
          }
          sports[sport].push(item)
        }
      })
      Object.keys(sports).forEach(key => {
        // By Club Name
        sports[key].sort((a, b) => {
          if (a.club.toLowerCase() < b.club.toLowerCase()) return -1
          if (a.club.toLowerCase() > b.club.toLowerCase()) return 1
          return 0
        })
        // By Order
        // sports[key].sort((a, b) => parseInt(a.order) - parseInt(b.order))
      })
      return sports
    },
    items() {
      const items = this.clubs.slice(0)
      return items.sort((a, b) => parseInt(a.order) - parseInt(b.order))
    },
    week() {
      if (this.weekId) {
        return this.weekId
      }
      return `${DateHelper.getWeekNumber()}`
    },
    year() {
      if (this.yearId) {
        return this.yearId
      }
      return `${DateHelper.getYearNumber()}`
    },
    weekDates() {
      const dates = DateHelper.getWeekDates(this.year, this.week)
      debug('getWeekDates', dates)
      return { firstDay: dates[0], lastDay: dates[6] }
    },
  },
  watch: {
    yearId() {
      this.bind()
    },
    weekId() {
      this.bind()
    },
    currentUser() {
      this.bind()
    },
    sports() {
      this.calculateMatches()
    },
    clubs(newValue, oldValue) {
      if (this.clubs) {
        this.clubs.map(club => {
          if (!club.hide) {
            const sport = SportHelper.getSportConfiguration(club.sport).sport
            if (sport === this.sport) {
              const year = this.year
              const week = this.week
              MatchesLib.bindAll(this, { clubId: club.id, year, week }, true)
            }
          }
        })
      }
    },
    matches_CKZkxVtg9xDJxfLsiR5m() {
      this.calculateMatches()
    },
    matches_cWi1M9kkSnKzFR2nVSgA() {
      this.calculateMatches()
    },
    matches_jkSUfpHeqkZautmWUEjt() {
      this.calculateMatches()
    },
    matches_xLEXpnK5LrQsH9HjjORc() {
      this.calculateMatches()
    },
    matches_ZLZLXhFHNIJGojpoa954() {
      this.calculateMatches()
    },
    matches_T96Sg3AyOJ9nT7yfjWN0() {
      this.calculateMatches()
    },
    matches_mkgu6Ss0GmjyjiGBJ8od() {
      this.calculateMatches()
    },
    matches_7DjVIkqn2eZcyw0X8uyE() {
      this.calculateMatches()
    },
    matches_wyASZ2GfBx4UfnLyFYAe() {
      this.calculateMatches()
    },
    matches_2LnrTngM5u8CJsmaQWJw() {
      this.calculateMatches()
    },
    matches_Q5HUpcnmLW3Xmj7o4P23() {
      this.calculateMatches()
    },
    matches_UpvnVcYqEAdNsZjLOxkP() {
      this.calculateMatches()
    },
    matches_eXX4oCnvJo8B9jJh6xis() {
      this.calculateMatches()
    },
    matches_hdyOC2C9KPq6aG7PBqxW() {
      this.calculateMatches()
    },
    matches_njeDdGOq4AwA7uUeMpVw() {
      this.calculateMatches()
    },
    matches_0HqZjr3UTM2tzWmjMfz2() {
      this.calculateMatches()
    },
    matches_1CjTqjZvfBgKNnY81inw() {
      this.calculateMatches()
    },
    matches_ZfMTnZ2rgYde5ICA4PPv() {
      this.calculateMatches()
    },
    matches_h0xCo3bcnXeGhSXt8XS8() {
      this.calculateMatches()
    },
    matches_X3d53YbJvGaFqyUt2tbh() {
      this.calculateMatches()
    },
    matches_GsOPPiTJbpbRwlBFN4YS() {
      this.calculateMatches()
    },
    matches_0OeHuu53VFk5dYtcXJDi() {
      this.calculateMatches()
    },
    matches() {
      debug('MATCHES CHANGE!!!!', this.matches)
    },
  },
  created() {
    debug('Club Model', clubModel, this)
  },
  mounted() {
    this.bind()
  },
  beforeDestroy() {},
  firestore: {},
  methods: {
    bind() {
      ClubsLib.bindAll(this)
      this.sports = SportHelper.getClubSportList()
      if (this.currentUser) {
        UserClubsLib.bindAll(this, { userId: this.currentUser.uid })
      } else {
        this.loadings.userClubs = false
      }
    },
    calculateMatches() {
      if (this.clubs) {
        debug('calculateMatches', 'ini')
        let matches = {}
        const matchesKeys = Object.keys(this).filter(key => key.indexOf('matches_') >= 0)
        matchesKeys.map(matchesKey => {
          this[matchesKey].map(match => {
            const club = this.clubs.find(club => club.id === match.clubId)
            if (club) {
              const sportId = match.sport || club.sport
              const sport = SportHelper.getSportConfiguration(sportId)

              if (sport) {
                debug('getMatchResult', match)
                const config = MatchHelper.config(sport)
                const result = MatchHelper.getMatchResult(config, match)
                const isMatchFinish = MatchHelper.isMatchFinish(config, match, result)
                const isMatchOnline = MatchHelper.isMatchOnline(config, match, isMatchFinish)
                const matchItem = Object.assign(match, result, {
                  clubName: club.club,
                  clubLogo: club.logo,
                  isMatchOnline,
                  isMatchFinish,
                })
                if (!matches[config.name]) {
                  matches[config.name] = {
                    config: config,
                    matches: [],
                  }
                }
                matches[config.name].matches.push(matchItem)
              }
            }
          })
        })
        debug('calculateMatches 2', matches)
        matches = _.values(matches)
        matches.sort((a, b) => {
          return b.matches.length - a.matches.length
        })
        matches.forEach(sport => {
          sport.matches.sort(
            (a, b) =>
              DateHelper.getDate(`${a.date} ${a.hour}`) - DateHelper.getDate(`${b.date} ${b.hour}`)
          )
        })
        debug('calculateMatches end', matches)
        this.matches = matches
      }
    },
    isClubAdmin(item) {
      if (this.userClubs) {
        return this.userClubs.find(club => club.id === item.id) !== null
      }
      return false
    },
    getSportName(item) {
      const sportId = item.sport || this.club.sport
      const sport = SportHelper.getSportConfiguration(sportId)
      return this.$t(`sport.types.${sport.sport}.name`)
    },
    onAdd(newItem) {
      debug('onAdd', newItem)
      ClubsLib.add(this, this.currentUser, newItem)
    },
    onUpdate(newItem, item) {
      debug('onUpdate', newItem, item)
      ClubsLib.update(this, this.currentUser, newItem, item)
    },
    onGo(item) {
      debug('onGo', item)
      if (this.yearId && this.weekId) {
        /*
        this.navigateTo({
          name: 'Club',
          params: { clubId: item.id, yearId: this.yearId, weekId: this.weekId },
        })
        */
      } else {
        // this.navigateTo({ name: 'Club', params: { clubId: item.id } })
      }
    },
    onDelete(item) {
      debug('onDelete', item)
      ClubsLib.delete(this, this.currentUser, item)
    },
    goMatch(match) {
      debug('goMatch', {
        clubId: match.clubId,
        year: match.year,
        week: match.week,
        matchId: match.id,
      })
      this.navigateTo({
        name: 'Match',
        params: { clubId: match.clubId, year: match.year, week: match.week, matchId: match.id },
      })
    },

    movePrevWeek() {
      const numWeekYear = 52
      let newYear = this.year
      let newWeek = parseInt(this.week) - 1
      if (newWeek < 1) {
        newWeek = numWeekYear
        newYear = parseInt(newYear) - 1
      }
      this.$router.push({
        name: 'Clubs',
        params: {
          yearId: `${newYear}`,
          weekId: `${newWeek}`,
          sport: this.sport,
        },
      })
    },
    moveNextWeek() {
      const numWeekYear = 52
      let newYear = this.year
      let newWeek = parseInt(this.week) + 1
      if (newWeek > numWeekYear) {
        newWeek = 1
        newYear = parseInt(newYear) + 1
      }
      this.$router.push({
        name: 'Clubs',
        params: {
          yearId: `${newYear}`,
          weekId: `${newWeek}`,
          sport: this.sport,
        },
      })
    },
  },
  head: {
    title: function() {
      return MetaHelper.getTitle('clubs')
    },
    meta: function() {
      return MetaHelper.getMeta('clubs', { name: 'Sports' })
    },
  },
}
</script>

<style lang="scss">
.custom-btn-toggle {
  .btn {
    opacity: 1;
  }
}
</style>
